"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSubsegments = exports.VideoProviders = exports.GroupScheduleType = exports.GroupDisplayType = exports.GroupCloseReason = exports.GroupStatus = exports.GroupType = void 0;
var GroupType;
(function (GroupType) {
    GroupType["Default"] = "default";
    GroupType["Workshop"] = "workshop";
    GroupType["OneOnOne"] = "one-on-one";
    GroupType["Community"] = "community";
    GroupType["PeerOnMany"] = "peer-on-many";
    GroupType["TrainingPeer"] = "training-peer";
    GroupType["OrganizationStrict"] = "organization-strict";
    GroupType["AudioRoom"] = "audio-room";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
var GroupStatus;
(function (GroupStatus) {
    GroupStatus["Active"] = "active";
    GroupStatus["Inactive"] = "inactive";
    GroupStatus["Locked"] = "locked";
    GroupStatus["Pending"] = "pending";
})(GroupStatus = exports.GroupStatus || (exports.GroupStatus = {}));
var GroupCloseReason;
(function (GroupCloseReason) {
    GroupCloseReason["LowAttendance"] = "low_attendance";
    GroupCloseReason["Merged"] = "merged";
    GroupCloseReason["MergedSecondCycle"] = "merged_second_cycle";
    GroupCloseReason["GfLeft"] = "gf_left";
    GroupCloseReason["NaturallyEnded"] = "naturally_ended";
    GroupCloseReason["GuideDidNotShowUp"] = "guide_did_not_show_up";
})(GroupCloseReason = exports.GroupCloseReason || (exports.GroupCloseReason = {}));
var GroupDisplayType;
(function (GroupDisplayType) {
    GroupDisplayType["Default"] = "default";
    GroupDisplayType["PremiumFacilitator"] = "premium_facilitator";
})(GroupDisplayType = exports.GroupDisplayType || (exports.GroupDisplayType = {}));
var GroupScheduleType;
(function (GroupScheduleType) {
    GroupScheduleType["Recurring"] = "recurring";
    GroupScheduleType["OnDemand"] = "on_demand";
    GroupScheduleType["ForLater"] = "for_later";
})(GroupScheduleType = exports.GroupScheduleType || (exports.GroupScheduleType = {}));
var VideoProviders;
(function (VideoProviders) {
    VideoProviders["Zoom"] = "zoom";
    VideoProviders["Twilio"] = "twilio";
})(VideoProviders = exports.VideoProviders || (exports.VideoProviders = {}));
var GroupSubsegments;
(function (GroupSubsegments) {
    GroupSubsegments["NarcParent"] = "narc_parent";
    GroupSubsegments["NarcPast"] = "narc_past";
    GroupSubsegments["NarcOngoing"] = "narc_ongoing";
    GroupSubsegments["GriefChild"] = "grief_child";
    GroupSubsegments["GriefParent"] = "grief_parent";
    GroupSubsegments["GriefSpouse"] = "grief_spouse";
    GroupSubsegments["GriefLovedOne"] = "grief_loved_one";
    GroupSubsegments["DivorceNoKids"] = "divorce_no_kids";
    GroupSubsegments["DivorceKids"] = "divorce_kids";
    GroupSubsegments["NarcOther"] = "narc_other";
    GroupSubsegments["GriefSuicide"] = "grief_suicide";
    GroupSubsegments["Other"] = "other";
    GroupSubsegments["DivorceOther"] = "divorce_other";
    GroupSubsegments["CaregiverForParent"] = "caregiver_for_parent";
    GroupSubsegments["CaregiverSpecialNeeds"] = "caregiver_special_needs";
    GroupSubsegments["CaregiverForSpouse"] = "caregiver_for_spouse";
    GroupSubsegments["ChronicCondition"] = "chronic_condition";
    GroupSubsegments["Disability"] = "disability";
    GroupSubsegments["FertilityNeverPregnant"] = "fertility_never_pregnant";
    GroupSubsegments["FertilityPregnantBefore"] = "fertility_pregnant_before";
    GroupSubsegments["FertilityOther"] = "fertility_other";
    GroupSubsegments["Parenting"] = "parenting";
    GroupSubsegments["PostpartumNewMom"] = "postpartum_new_mom";
    GroupSubsegments["Relocation"] = "relocation";
    GroupSubsegments["Seniors"] = "seniors";
})(GroupSubsegments = exports.GroupSubsegments || (exports.GroupSubsegments = {}));
//# sourceMappingURL=group.js.map